/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Etos_UnifiedAwardImport_UnifiedAwardImportEto } from '../models/Wealthlane_Shared_Hosting_Etos_UnifiedAwardImport_UnifiedAwardImportEto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UnifiedAwardImportEventHandlerService {

    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppUnifiedAwardImportEventHandlerUnifiedAwardImportEventHandler(
        requestBody?: Wealthlane_Shared_Hosting_Etos_UnifiedAwardImport_UnifiedAwardImportEto,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/unified-award-import-event-handler/unified-award-import-event-handler',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
